export default __webpack_public_path__ + "static/logo-ey-dark-d58115d1157aee3210f3e446746b93f1.svg";